// tslint:disable-next-line:max-line-length
import { Directive, Input, AfterViewInit, OnDestroy, Output, EventEmitter, Renderer2, HostListener, PLATFORM_ID, Inject, ElementRef } from '@angular/core';
import { DOCUMENT, isPlatformBrowser, isPlatformServer } from '@angular/common';
// import * as fullpage from 'fullpage.js';

declare var require: any;

let fullpage: any = null;

// if (!fullpage && typeof window !== 'undefined') {
//   fullpage = require('fullpage.js/dist/fullpage.extensions.min');
// }

// if (!fullpage && typeof window !== 'undefined') {
//   fullpage = require('fullpage.js/dist/np-fullpage');
// }

if (!fullpage && typeof window !== 'undefined') {
  fullpage = require('./np-fullpage.js');
}

@Directive({
  // tslint:disable-next-line:directive-selector
  selector: '[href]'
})
export class AnchorLinkDirective {
  @Input() href!: string;

  @HostListener('click', ['$event']) onClick(event: any) {
    if (this.href.length > 0 && this.href[0] === '#') {
      event.preventDefault();
      window.location.hash = this.href;
    }
  }
}

@Directive({
  // tslint:disable-next-line:directive-selector
  selector: '[np-fullpage]',
})
export class NpFullpageDirective implements AfterViewInit, OnDestroy {

  @Input() id: any;
  @Input('options') options: any;
  @Output() ref = new EventEmitter();

  fullpage_api: any;

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    @Inject(DOCUMENT) private document: Document,
    private el: ElementRef,
    private renderer: Renderer2
  ) { }

  ngAfterViewInit() {
    if (isPlatformBrowser(this.platformId)) {
      this.initFullpage();
    }
    if (isPlatformServer(this.platformId)) {
      // server side code
    }
  }

  initFullpage() {
    let elNative = this.el.nativeElement;
    this.renderer.addClass(elNative, 'np-fullpage-wrapper');
    this.fullpage_api = new fullpage(elNative, this.options);
    // this.fullpage_api.silentMoveTo(1)
    // this.fullpage_api.silentMoveTo(1);
    // this.fullpage_api = new fullpage('#' + this.id, this.options);
    this.addBuildFunction();
    this.ref.emit(this.fullpage_api);
  }

  addBuildFunction() {
    this.fullpage_api.build = () => {
      const activeSection = this.fullpage_api.getActiveSection();
      const activeSlide = this.fullpage_api.getActiveSlide();

      this.destroyFullpage();

      if (activeSection) {
        this.renderer.addClass(activeSection.item, 'active');
      }

      if (activeSlide) {
        this.renderer.addClass(activeSlide.item, 'active');
      }

      this.initFullpage();
    };
  }

  destroyFullpage() {
    if (typeof this.fullpage_api !== 'undefined' && typeof this.fullpage_api.destroy !== 'undefined') {

      // 원래코드
      this.fullpage_api.silentMoveTo(1)
      this.fullpage_api.destroy();


      // if (all) {
      // 이거 호출 되면 에러 발생
      // this.fullpage_api.destroyStructure();
      // }

      this.renderer.removeClass(this.document.documentElement, 'fp-enabled');
      let bodyClassNames = this.document.body.className.split(" ");
      bodyClassNames.forEach(v => {
        if (v.startsWith('fp-')) {
          this.renderer.removeClass(this.document.body, v);
        }
      })
      const fpNav = this.document.getElementById('fp-nav');
      if (fpNav) {
        this.renderer.removeChild(this.document.body, fpNav);
      }

      let xWin: any = window;
      if (xWin) {
        delete xWin.fullpage_api;
        delete xWin.fullpage_extensions;
        delete xWin.fp_easings;
        delete xWin.fp_scrolloverflow;
        delete xWin.fp_utils;
      }
    }
  }

  // destroyFullpage() {
  //   if (typeof this.fullpage_api !== 'undefined' && typeof this.fullpage_api.destroy !== 'undefined') {
  //     this.fullpage_api.destroy('all');
  //   }
  // }

  async ngOnDestroy() {
    this.destroyFullpage();
    // await NpThreadUtils.wait(1000);
  }
}


